import { createAction, props } from "@ngrx/store";
import { SkillsCheckTabActionTypes } from "src/app/constants/StoreConstants";
import { SkillsCheckPanel } from "src/app/_models/SkillsCheck";

export const IsSkillsCheckEnabled = createAction(
  SkillsCheckTabActionTypes.IsSkillsCheckEnabled,
  props<{ courseId: number }>()
);

export const IsSkillsCheckEnabledSuccess = createAction(
  SkillsCheckTabActionTypes.IsSkillsCheckEnabledSuccess,
  props<{ isEnabled: boolean }>()
);

export const IsSkillsCheckEnabledError = createAction(
  SkillsCheckTabActionTypes.IsSkillsCheckEnabledError,
  props<{ error: any }>()
);

export const GetSkillsCheckResult = createAction(
  SkillsCheckTabActionTypes.GetSkillsCheckResult,
  props<{ courseId: number }>()
);

export const GetSkillsCheckResultByLearnerId = createAction(
  SkillsCheckTabActionTypes.GetSkillsCheckResultByLearnerId,
  props<{learnerId: number, courseId: number}>()
);

export const GetSkillsCheckResultSuccess = createAction(
  SkillsCheckTabActionTypes.GetSkillsCheckResultSuccess,
  props<{ panel: SkillsCheckPanel[] }>()
);

export const GetSkillsCheckResultError = createAction(
  SkillsCheckTabActionTypes.GetSkillsCheckResultError,
  props<{ error: any }>()
);

export const UpdatePanelState = createAction(
  SkillsCheckTabActionTypes.UpdatePanelState,
  props<{
    courseId: number;
    name: string;
    expandPanel: boolean;
    showHideQandA: boolean;
  }>()
);

export const UpdateAttemptPanelState = createAction(
  SkillsCheckTabActionTypes.UpdateAttemptPanelState,
  props<{
    name: string;
    learnerTargetOutcomeId: number;
    expandedAttempt: boolean;
    showAttemptQandA: boolean;
  }>()
);

export const UpdateAttemptPanelStateSuccess = createAction(
  SkillsCheckTabActionTypes.UpdateAttemptPanelStateSuccess
);

export const UpdatePanelStateSuccess = createAction(
  SkillsCheckTabActionTypes.UpdatePanelStateSuccess
);
export const UpdateSkillsCheckTabState = createAction(
  SkillsCheckTabActionTypes.UpdateSkillsCheckPanelState
);

export const IsSkillsCheckEnabledByLearnerId = createAction(
  SkillsCheckTabActionTypes.IsSkillsCheckEnabledByLearnerId,
  props<{learnerId: number, courseId: number}>()
);

export const ResetSkillsCheckState = createAction(
  SkillsCheckTabActionTypes.ResetSkillsCheckState
);